<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title
    [text]="'Live Production'"
    [accent]="nbActives() + ' / ' + nbTotal()"
    [widget]="widget()"
    [draggable]="true">
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
  </vl-widget-title>

  <!-- Toolbar : settings menu + bouton plein écran -->
  <div class="flex-row gap-4 align-center" style="padding: 0 8px">
    <button mat-button [matMenuTriggerFor]="settingsMenu" type="button"
            class="settings-btn" matTooltip="Paramètres">
      <mat-icon>tune</mat-icon>
    </button>
    <mat-menu #settingsMenu="matMenu" class="live-settings-menu">
      <div class="menu-section">
        <div class="menu-section-title caption strong on-background-alt">Filtres</div>
        <label class="menu-checkbox-row" (click)="$event.stopPropagation()">
          <mat-checkbox [checked]="prefs.onlyDevices()"
                        (change)="prefs.onlyDevices.set($event.checked)">
            Avec automate uniquement
          </mat-checkbox>
        </label>
        <label class="menu-checkbox-row" (click)="$event.stopPropagation()">
          <mat-checkbox [checked]="prefs.hideInactive()"
                        (change)="prefs.hideInactive.set($event.checked)">
            Masquer inactives
          </mat-checkbox>
        </label>
      </div>
      <mat-divider/>
      <div class="menu-section">
        <div class="menu-section-title caption strong on-background-alt">Lignes</div>
        <div class="menu-lignes-list">
          @for (l of allLignes(); track l.ligneId) {
            <label class="menu-checkbox-row" (click)="$event.stopPropagation()">
              <mat-checkbox [checked]="!prefs.isHidden(l.ligneId)"
                            (change)="prefs.toggleHidden(l.ligneId)">
                {{ l.ligneDenomination }}
              </mat-checkbox>
            </label>
          }
        </div>
        @if (hiddenCount() > 0) {
          <button mat-button class="menu-action-btn" (click)="showAllLignes()" type="button">
            <mat-icon>visibility</mat-icon>
            Afficher toutes ({{ hiddenCount() }} masquée(s))
          </button>
        }
      </div>
    </mat-menu>

    <button type="button" class="fullscreen-btn"
            (click)="openFullscreen($event)"
            matTooltip="Ouvrir la supervision en fenêtre détachée"
            data-testid="btn-live-fullscreen">
      <mat-icon>open_in_new</mat-icon>
    </button>
  </div>

  @if (loading() && visibleLignes().length === 0) {
    <div class="flex-col gap-12 widget-content">
      <ngx-skeleton-loader count="5" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else if (visibleLignes().length > 0) {
    <div class="flex-col widget-content fade-in" style="overflow: auto; min-height: 0">
      @for (ligne of visibleLignes(); track ligne.ligneId) {
        <vl-live-line-row
          [ligne]="ligne"
          [cadence]="cadenceFor(ligne.ligneId)"
          (open)="onLineOpen($event)"/>
      }
    </div>
  } @else {
    <div class="flex-col align-center justify-center" style="padding: 24px; gap: 8px">
      <span class="caption on-disabled">Aucune ligne à afficher.</span>
      @if (hiddenCount() > 0) {
        <button mat-button (click)="showAllLignes()" type="button">
          Afficher les {{ hiddenCount() }} ligne(s) masquée(s)
        </button>
      }
    </div>
  }
</div>
